import React from 'react';
import { Form } from 'react-bootstrap';

export const TextInput = (props) => {

    const handleValueChange = (e) => {
        props.setValue(e.target.value)
    }

    return (
        <Form.Control type="text" value={props.value} onChange={(e) => handleValueChange(e)} disabled={props.disabled} />
    )
}